import { Box, Button, Typography } from "@mui/material";
import { setRejectModalOpen } from "../../store/job/jobSlice";
import { useDispatch } from "react-redux";

const ProofFooter = ({
  proof_data,
  onApprove,
  onReject,
  is_reject_modal_open,
  reject_comment,
  showAnnotated,
}) => {
  const dispatch = useDispatch();
  const allApproved = proof_data?.some(
    (item) => item.sent_approved_files === 2,
  );
  const allRejected = proof_data?.every(
    (item) => item.sent_approved_files === 3,
  );

  const isCommentsPresent = proof_data?.some(
    (item) => item.proof_comments && item.proof_comments.length > 0,
  );

  const handleApproveClick = () => {
    if (isCommentsPresent) {
      alert(
        'Please click on "Need Changes" as you have already added the comments.',
      );
    } else {
      onApprove();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        mt: 2,
        mb: 2,
        pr: "20px",
        py: 1,
      }}
    >
      {/* <Typography variant="h6" sx={{ fontWeight: 600, fontFamily: "'Inter Tight', sans-serif" }}>
        Proof Approval
      </Typography> */}
      {/* Status Text (Center) */}
      {allApproved ? (
        <Typography variant="subtitle1" color="success.main">
          {proof_data?.find((item) => item.approved_proof)?.approved_proof
            ? `${
                proof_data.find((item) => item.approved_proof).approved_proof
              } Already Approved`
            : "Already Approved"}
        </Typography>
      ) : allRejected ? (
        <Typography variant="subtitle1" color="error.main">
          Already Rejected
        </Typography>
      ) : (
        /* Buttons (Right, Absolute) */
        <Box
          sx={{
            position: "absolute",
            right: "20px",
            top: "50%",
            transform: "translateY(-50%)",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{ mr: 1 }}
            onClick={handleApproveClick}
          >
            Approve
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => dispatch(setRejectModalOpen(true))}
          >
            {showAnnotated ? "Need Changes" : "Reject"}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ProofFooter;
